// src/Routes/AdminRoutes.js
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import {ProtectedComponent} from '../Pages/Authentication'; 
import {ProfileSettings, EmailSmsAlerts} from '../Pages/ProfileManagement'; 
import NotFoundPage from '../Components/NotFoundPage'; 
import { GlobalInfo } from '../Contexts/GlobalContext';
import AddAddresses from '../Pages/ProfileManagement/AddAddresses';
import GetPaid from '../Pages/ProfileManagement/GetPaid';

const ProfileManagementRoutes = () => {
  const { isSidebarVisible } = useContext(GlobalInfo);
  const { isRestrictedPage  } = useContext(GlobalInfo);
  
  return (
    <div className={`${!isRestrictedPage ? 'el-middle' : ''} ${!isSidebarVisible ? 'collapsed-body' : ''}`}>
      <Routes>
        <Route path="profile-settings" element={<ProfileSettings requiredRole="" />} />
        <Route path="/profile-settings/add-address" element={<AddAddresses requiredRole="" />} />
        <Route path="email-sms-alerts" element={<EmailSmsAlerts requiredRole="" />} />
        <Route path="get-paid" element={<GetPaid requiredRole="" />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};
export default ProfileManagementRoutes;
